<template>
  <EdroneAlert
    class="tw:w-full tw:border-0 tw:border-b tw:border-default-200 tw:rounded-none tw:p-4"
    type="ai"
    is-vertical
    :title="trans._readyFlows.smartInsight.header.title"
    :desc="trans._readyFlows.smartInsight.header.desc"
    :buttons="[
      {
        text: trans._readyFlows.smartInsight.header.btn,
        icon: 'fa-light fa-arrow-right',
        type: 'solid',
        id: 'smart-insight-check-insight-btn',
        onClick: () => $emit('click'),
      },
    ]"
  >
    <template #custom-icon>
      <i class="fa-kit fa-solid-chart-line-sparkle"></i>
    </template>
  </EdroneAlert>
</template>

<script setup lang="ts">
import EdroneAlert from "edrone-components/EdroneAlert.vue";

defineEmits(["click"]);
</script>
